import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useScreenStore = defineStore('screen', () => {
    const isWideOrLandscape = ref<boolean>()

    const updateLayoutFlag = () => {
        if (typeof window === 'undefined') return
        const { innerWidth: w, innerHeight: h } = window

        // wide screen OR landscape
        isWideOrLandscape.value = w >= 1024 || w > h
    }

    return {
        // State
        isWideOrLandscape,

        // Methods
        updateLayoutFlag,
    }
})
